<template>
  <Timeline
    :title="$t('nav.timeline')"
    :timeline="timeline"
    :timeline-name="'friends'"
  />
</template>

<script src="./friends_timeline.js"></script>
